export type Language = 'de' | 'tr' | 'en' | 'ar';

export const SUPPORTED_LANGUAGES: { code: Language; label: string; dir: 'ltr' | 'rtl' }[] = [
  { code: 'de', label: 'Deutsch', dir: 'ltr' },
  { code: 'tr', label: 'Türkçe', dir: 'ltr' },
  { code: 'en', label: 'English', dir: 'ltr' },
  { code: 'ar', label: 'العربية', dir: 'rtl' },
];

export interface Translations {
  dir: 'ltr' | 'rtl';
  // Nav
  navAbout: string;
  navHistory: string;
  navFeatures: string;
  navRecentDonations: string;
  navFaq: string;
  navTeam: string;
  navMembership: string;
  navAnnouncements: string;
  navContact: string;
  // Recent Donations
  recentDonationsTitle: string;
  recentDonationsSubtitle: string;
  recentDonationsLive: string;
  recentDonationsRaised: string;
  recentDonationsGoal: string;
  recentDonationsDonors: string;
  recentDonationsAgo: string;
  recentDonationsShowMore: string;
  // Hero
  heroSubtitle: string;
  heroCampaignTitle: string;
  heroCampaignSubtitle: string;
  heroSliderQuote: string;
  heroTitle: string;
  heroQuote: string;
  heroQuoteSource: string;
  heroCTA: string;
  // About
  aboutTitle: string;
  aboutSubtitle: string;
  aboutText: string;
  aboutMosqueTitle: string;
  aboutMosqueText: string;
  aboutNewTitle: string;
  aboutNewText1: string;
  aboutNewText2: string;
  aboutNewText3: string;
  aboutNewCallTitle: string;
  // Inspiration
  inspirationTitle: string;
  inspirationSubtitle: string;
  inspirationCardTitle: string;
  inspirationCardText: string;
  // History
  historyTitle: string;
  historySubtitle: string;
  step1Title: string;
  step1Text: string;
  step2Title: string;
  step2Text: string;
  step3Title: string;
  step3Text: string;
  step4Title: string;
  step4Text: string;
  // Mosque Features
  featuresTitle: string;
  featuresSubtitle: string;
  basementTitle: string;
  basement1: string;
  basement1Text: string;
  basement2: string;
  basement2Text: string;
  groundFloorTitle: string;
  ground1: string;
  ground1Text: string;
  ground2: string;
  ground2Text: string;
  firstFloorTitle: string;
  first1: string;
  first1Text: string;
  first2: string;
  first2Text: string;
  secondFloorTitle: string;
  second1: string;
  second1Text: string;
  // Donation Process
  donationTitle: string;
  donationSubtitle: string;
  dStep1Title: string;
  dStep1Text1: string;
  dStep1Text2: string;
  dStep1Text3: string;
  dStep2Title: string;
  dStep2Text: string;
  dStep2Text2: string;
  dStep3Title: string;
  dStep3Text: string;
  dStep4Title: string;
  dStep4Text1: string;
  dStep4Text2: string;
  // Donation Form
  formTitle: string;
  formSubtitle: string;
  formAmountLabel: string;
  formCustomAmount: string;
  formPaymentMethod: string;
  formCreditCard: string;
  formPaypal: string;
  formBankTransfer: string;
  formName: string;
  formEmail: string;
  formMessage: string;
  formSubmit: string;
  formBankDetails: string;
  formBankName: string;
  formIBAN: string;
  formBIC: string;
  formReference: string;
  formCardNumber: string;
  formExpiry: string;
  formCVV: string;
  formCardHolder: string;
  formPaypalInfo: string;
  // FAQ
  faqTitle: string;
  faqSubtitle: string;
  faq1Q: string;
  faq1A: string;
  faq2Q: string;
  faq2A: string;
  faq3Q: string;
  faq3A: string;
  faq4Q: string;
  faq4A: string;
  faq5Q: string;
  faq5A: string;
  faq6Q: string;
  faq6A: string;
  // Thank You
  thankTitle: string;
  thankSubtitle: string;
  thankImamLabel: string;
  thankImamName: string;
  thankImamText: string;
  thankImamClose: string;
  thankImamOrg: string;
  thankCTA: string;
  // Footer
  footerTax: string;
  footerTaxText: string;
  footerImpressum: string;
  footerDatenschutz: string;
  footerDesign: string;
  donateNow: string;
  // Contact Page
  contactTitle: string;
  contactSubtitle: string;
  contactAddress: string;
  contactPhone: string;
  contactEmail: string;
  contactFormTitle: string;
  contactFormName: string;
  contactFormEmail: string;
  contactFormPhone: string;
  contactFormSubject: string;
  contactFormMessage: string;
  contactFormSubmit: string;
  contactFormSuccess: string;
  contactFormError: string;
  contactFindUs: string;
  contactOpeningHours: string;
  // Prayer Times
  prayerTimesTitle: string;
  prayerTimesLocation: string;
  nextPrayer: string;
  prayerImsak: string;
  prayerFajr: string;
  prayerSunrise: string;
  prayerDhuhr: string;
  prayerAsr: string;
  prayerMaghrib: string;
  prayerIsha: string;
  prayerDaily: string;
  prayerWeekly: string;
  prayerNote: string;
  // Cookie Consent
  cookieTitle: string;
  cookieText: string;
  cookieAccept: string;
  cookieReadMore: string;
  // Contact CTA (homepage)
  contactCtaTitle: string;
  contactCtaSubtitle: string;
  contactCtaButton: string;
  // Impressum page headers
  impressumPageTitle: string;
  impressumPageSubtitle: string;
  // Datenschutz page headers
  datenschutzPageTitle: string;
  datenschutzPageSubtitle: string;
  // Team page
  teamPageTitle: string;
  teamPageSubtitle: string;
  // Announcements
  announcementsBadge: string;
  announcementsPageSubtitle: string;
  announcementsEmpty: string;
  announcementsViewAll: string;
  announcementsReadMore: string;
  // Contact extras
  contactAddressLabel: string;
  contactEmailLabel: string;
  contactOpen24h: string;
  contactSending: string;
  // Membership
  membershipTitle: string;
  membershipOrgName: string;
  membershipSuccessTitle: string;
  membershipSuccessText: string;
  membershipBackHome: string;
  membershipSubmit: string;
  membershipSending: string;
}

const de: Translations = {
  dir: 'ltr',
  navAbout: 'Über Uns',
  navHistory: 'Geschichte',
  navFeatures: 'Merkmale',
  navRecentDonations: 'Letzte Spenden',
  navFaq: 'FAQ',
  navTeam: 'Vorstand',
  navMembership: 'Aufnahmeantrag',
  navAnnouncements: 'Ankündigungen',
  navContact: 'Kontakt',
  recentDonationsTitle: 'Letzte Spenden',
  recentDonationsSubtitle: 'Unsere Gemeinschaft wächst – jede Spende bringt uns näher zum Ziel',
  recentDonationsLive: '🔴 Live',
  recentDonationsRaised: 'Bisher gesammelt',
  recentDonationsGoal: 'Gesamtziel',
  recentDonationsDonors: 'Spender',
  recentDonationsAgo: 'vor',
  recentDonationsShowMore: 'Mehr anzeigen',
  // Prayer Times
  prayerTimesTitle: 'Gebetszeiten',
  prayerTimesLocation: 'Willich, Deutschland',
  nextPrayer: 'Nächstes Gebet',
  prayerImsak: 'Imsak',
  prayerFajr: 'Fajr',
  prayerSunrise: 'Sonnenaufgang',
  prayerDhuhr: 'Dhuhr',
  prayerAsr: 'Asr',
  prayerMaghrib: 'Maghrib',
  prayerIsha: 'Ischa',
  prayerDaily: 'Täglich',
  prayerWeekly: 'Wöchentlich',
  prayerNote: 'Die Gebetszeiten sind berechnet und können einige Minuten von den tatsächlichen Zeiten abweichen.',
  heroSubtitle: 'Türkisch Islamische Gemeinde',
  heroCampaignTitle: 'Willich Moschee Spendenkampagne',
  heroCampaignSubtitle: 'Jede Spende zählt!',
  heroTitle: 'WILLICH',
  heroQuote: '"Errichtet jemand eine Moschee, um damit die Zufriedenheit und das Wohlwollen von Allah zu erlangen, wird Allah ihm hierfür ein Haus im Paradies vorbereiten."',
  heroQuoteSource: '(Prophet Muhammed ﷺ) — Buhâri, Salât 65; Müslim, Mesâcid 25, (533)',
  heroCTA: 'Jetzt Sicher Spenden',
  heroSliderQuote: 'Die Hilfe, die Sie jetzt für unsere Gemeinde leisten, wird ein Geschenk für diese und die kommenden Generationen!',
  aboutTitle: 'Ditib Türkische Islamische Gemeinde zu Willich e.V.',
  aboutSubtitle: 'Seit 1979',
  aboutText: 'besteht die DITIB Türkisch Islamische Gemeinde zu Willich e. V. als ein registrierter gemeinnütziger Verein in Willich. Ursprünglich gegründet von den ersten türkischen Gastarbeitern in der Region, wurde der Verein ins Leben gerufen, um den wachsenden Bedarf an einer gemeinsamen Gebetsstätte für Muslime zu erfüllen.',
  aboutMosqueTitle: 'Die Eröffnung unserer Moschee',
  aboutMosqueText: 'Unsere Moschee wurde 1979 eröffnet. Anfangs wurden die Räumlichkeiten der Moschee gemietet, doch im Laufe der Zeit wurde es dank der Unterstützung unserer Vereinsmitglieder und engagierter Muslime möglich, das Gebäude zu erwerben. Im Verlauf der Jahre konnte auch das Nebengebäude erworben werden, das für religiösen Unterricht und als Aufenthaltsraum genutzt wurde. Trotz laufender Renovierungsarbeiten reichte die Instandhaltung der alten Moschee im Laufe der Jahre nicht aus.',
  aboutNewTitle: 'DITIB Willich Zentralmoschee',
  aboutNewText1: 'Die offizielle Genehmigung für unser DITIB Willich Zentralmoschee-Projekt wurde 2023 erteilt, der Bauprozess begann 2025. Dieses bedeutende Projekt zielt darauf ab, unserer Gemeinschaft in Willich ein modernes Zentrum für Anbetung, Bildung, Kultur und soziale Solidarität zu bieten.',
  aboutNewText2: 'Unsere Moschee ist nicht nur ein Ort der Anbetung, sondern auch ein wichtiges Lebenszentrum, in dem unsere Kinder und Jugendlichen Bildung erhalten, unsere Familien zusammenkommen und Veranstaltungen stattfinden können, die den gesellschaftlichen Zusammenhalt stärken.',
  aboutNewText3: 'Dieses Projekt, das durch die Unterstützung unserer Gemeinschaft, die Arbeit unserer Freiwilligen und die Beiträge unserer Wohltäter vorangetrieben wird, macht auf seinem Weg zu einem dauerhaften Vermächtnis für zukünftige Generationen stetige Fortschritte.',
  aboutNewCallTitle: 'Gemeinsam sind wir stark, gemeinsam sind wir erfolgreich.',
  inspirationTitle: 'Unsere Inspiration:',
  inspirationSubtitle: 'Die Hagia Sophia',
  inspirationCardTitle: 'Die Kuppel der Hagia Sophia',
  inspirationCardText: 'Auf dem Grund des ehemaligen Moscheegebäudes soll eine für die gesamte Region Willich repräsentative Moschee erbaut werden, die den Wünschen der Gemeindemitglieder (Kinder, Jugendliche, Familien und Senioren) und den Besuchern gerecht wird. Um der architektonischen Landschaft in Willich mehr Farbe zu verleihen, soll die Moschee im klassischen Stil erbaut werden und eine Kuppel haben, ganz wie das Vorbild der Hagia Sophia.',
  historyTitle: 'Unsere Geschichte',
  historySubtitle: 'Wie alles begann …',
  step1Title: 'Gründung',
  step1Text: '1979 entschlossen sich ehemalige Gastarbeiter zur Gründung der DITIB Türkisch Islamischen Gemeinde zu Willich e. V. Die Notwendigkeit einer eigenen Gebetsstätte führte zur späteren Anschaffung eines Grundstückes. Das erworbene Grundstück beherbergte ursprünglich eine Lagerhalle, mit Wohnungen, einer Küche, mehreren Lehrräumen und einem eigenen Fitnessstudio. Schließlich wurden Umbauarbeiten durchgeführt und das Gebäude in eine Moschee umgewandelt.',
  step2Title: 'Grundsteinlegung',
  step2Text: 'Mit dem kontinuierlichen Wachstum der Gemeinde und dem steigenden Bedarf für erweiterte Räumlichkeiten entschied sich der Vorstand aufgrund des jahrelangen Schuldenabbaus, für einen nur durch Spenden finanzierten Neubau eines Moschee-Gebäudes und eines Kulturzentrums. Im Jahr 2014 wurden die ersten Bauanträge eingereicht. Nach Erhalt der Baugenehmigung begann im Jahr 2017 der Abriss des alten Gebäudes. Schließlich, am 12.10.2018, erfolgte die langersehnte Grundsteinlegung.',
  step3Title: 'Heute',
  step3Text: 'Während gerade der Rohbau begonnen hatte, zwang Corona zu einem Stillstand der Bauarbeiten. Diese Unterbrechung führte nicht nur zu Zeitverlust, sondern trieb auch die Preise der benötigten Materialien in die Höhe. Trotz vieler Hürden wurde im Verlauf des Jahres 2022 der Rohbau erfolgreich fertiggestellt. Heute sind die Marmorarbeiten im Gebetsbereich und auch die Außendämmung vollendet.',
  step4Title: 'Zukunft',
  step4Text: 'Obwohl der Plan, die Moschee innerhalb von 4 Jahren fertigzustellen, leider nicht aufging, haben wir Vertrauen in unsere Spenderinnen und Spender und verfolgen das Ziel, InshaAllah die Moschee bald zu eröffnen.',
  featuresTitle: 'Die Eigenschaften der neuen Moschee',
  featuresSubtitle: 'Bilder von unserem Moscheebau-Projekt',
  basementTitle: 'Kellergeschoss',
  basement1: '1. Teestube & Mehrzweckraum',
  basement1Text: 'Die geplante Teestube und der Mehrzweckraum dienen als zentraler Ort des Zusammentreffens. Hier können Muslime verschiedener Kulturen aufeinandertreffen und die Kommunikation innerhalb der Gemeinde stärken.',
  basement2: '2. Fitnessraum',
  basement2Text: 'Wir sind der festen Überzeugung, dass nicht nur die geistige, sondern auch die physische Gesundheit eine essenzielle Rolle dabei spielt, eine Balance im Leben aufzubauen.',
  groundFloorTitle: 'Erdgeschoss',
  ground1: '1. Damen und Herren Gebetsräume',
  ground1Text: 'Auf einer Fläche von 440m² haben alle Muslime die Möglichkeit, ihre verschiedenen gottesdienstlichen Handlungen auszuüben. Mithilfe der getrennten Räumlichkeiten für Männer und Frauen kann jeder seinen heiligen Pflichten wie dem fünfmaligen täglichen Gebet nachkommen.',
  ground2: '2. Aufzug & behindertengerechte WCs',
  ground2Text: 'Ein Aufzug und der Einbau von behindertengerechten Toiletten sollen den Besuch der Willicher Moschee für jeden ermöglichen und vereinfachen.',
  firstFloorTitle: 'Erstes Obergeschoss',
  first1: '1. Bibliothek',
  first1Text: 'Ein Ort der Weiterbildung soll errichtet werden, an dem sich die Besucher der Willicher Moschee in Lehrbücher einlesen und neues Wissen über den Islam aneignen können.',
  first2: '2. Jugendräume',
  first2Text: 'Die Willicher Moschee beinhaltet ebenfalls speziell angepasste Räumlichkeiten für unsere jugendliche Community. Diese Räume sollen einen Rückzugsort bilden und den Jugendlichen die Gelegenheit schenken, qualitativ Zeit miteinander zu verbringen.',
  secondFloorTitle: 'Zweites Obergeschoss',
  second1: '1. Besucher Unterkunft — Es befinden sich drei Wohnungen im zweiten Obergeschoss für unsere Besucher.',
  second1Text: 'Im zweiten Obergeschoss befinden sich drei Wohnungen für unsere Besucher.',
  donationTitle: 'Spendenverlauf',
  donationSubtitle: 'Jede Spende zählt!',
  dStep1Title: 'Step 1 - Flexibler Betrag',
  dStep1Text1: 'Sie entscheiden im ersten Schritt, wie viel Sie spenden möchten und geben diesen Betrag an.',
  dStep1Text2: 'Bereits eine kleine Spende von 1 € kann unserer Gemeinde eine große Unterstützung sein und die Bauarbeiten voranbringen.',
  dStep1Text3: 'So zögern Sie nicht, denn schon mit der kleinsten Spende können Sie etwas Großes bewirken!',
  dStep2Title: 'Step 2 - Viele Zahlungsmöglichkeiten',
  dStep2Text: 'Als Nächstes werden Ihnen verschiedene Zahlungsmöglichkeiten angeboten, von denen Sie sich eine aussuchen müssen.',
  dStep2Text2: 'Eine zuverlässige Spendendurchführung ist uns an dieser Stelle von besonderer Wichtigkeit. Demzufolge versprechen wir Ihnen 100 % Transparenz und Sicherheit.',
  dStep3Title: 'Step 3 - Spendenbestätigung',
  dStep3Text: 'Sobald Sie Ihre gewünschte Zahlungsmethode ausgewählt haben, können Sie den Spendenprozess abschließen. Möge Allah Ihnen ein Haus in al–Jannah gewähren.',
  dStep4Title: 'Step 4 - Transparenz',
  dStep4Text1: 'Um Ihnen die versicherte Transparenz gewährleisten zu können, erhalten Sie von uns, nach Eingang der Spende, eine Spendenbestätigung.',
  dStep4Text2: 'Die eingehenden Spenden werden ausschließlich für die Anschaffung von benötigten Materialien und für fortlaufende Bauarbeiten genutzt.',
  formTitle: 'Jetzt Sicher Spenden',
  formSubtitle: 'DITIB WILLICH Moschee Spendenkampagne',
  formAmountLabel: 'Spendenbetrag wählen',
  formCustomAmount: 'Eigener Betrag (€)',
  formPaymentMethod: 'Zahlungsmethode',
  formCreditCard: 'Kreditkarte',
  formPaypal: 'PayPal',
  formBankTransfer: 'Banküberweisung',
  formName: 'Vor- und Nachname',
  formEmail: 'E-Mail-Adresse',
  formMessage: 'Nachricht (optional)',
  formSubmit: 'Jetzt Spenden',
  formBankDetails: 'Bankverbindung',
  formBankName: 'DITIB Türkisch Islamische Gemeinde zu Willich e.V.',
  formIBAN: 'IBAN: DE12 3456 7890 1234 5678 90',
  formBIC: 'BIC: DEUTDEDB',
  formReference: 'Verwendungszweck: Moschee Neubau Willich',
  formCardNumber: 'Kartennummer',
  formExpiry: 'Ablaufdatum',
  formCVV: 'CVV',
  formCardHolder: 'Karteninhaber',
  formPaypalInfo: 'Sie werden zu PayPal weitergeleitet, um Ihre Spende sicher abzuschließen.',
  faqTitle: 'Q&A',
  faqSubtitle: 'Häufig gestellte Fragen',
  faq1Q: 'Was passiert mit meiner Spende?',
  faq1A: 'Ihre Spende bildet die Basis der Bauarbeiten. Mithilfe eingehender Spenden werden die einzelnen wichtigen Bauphasen gefördert.',
  faq2Q: 'Wer ist Ditib eigentlich?',
  faq2A: 'Ditib ist ein türkisch islamischer Verein in Deutschland, der sich für die Förderung und den Erhalt der türkischen Kultur und des Islams einsetzt. Gegründet wurde er 1984 von der türkischen Regierung und ist mit 900 Moscheen und über 900.000 Mitgliedern der größte Anbieter von Moscheen und der islamischen Religionslehre deutschlandweit.',
  faq3Q: 'Wie erfahre ich, ob meine Spende eingegangen ist?',
  faq3A: 'Um Ihnen eine nachvollziehbare Spendenabwicklung zu ermöglichen, erhalten Sie nach Eingang Ihrer Spende eine digitale Bestätigung.',
  faq4Q: 'Wird die Moschee mit Zinsen erbaut?',
  faq4A: 'Die Erhebung und Auszahlung von Zinsen ist im Islam nicht gestattet. Der Bau unserer Moschee konnte mithilfe unserer Gemeindemitglieder gestartet und bislang ohne jeglichen Einfluss von Zinsen finanziert werden.',
  faq5Q: 'Ist meine Spende steuerlich absetzbar?',
  faq5A: 'Ja, da wir als gemeinnütziger Verein anerkannt sind, können Sie Ihre Spende steuerlich absetzen. Sie erhalten nach Ihrer Spende eine Spendenquittung.',
  faq6Q: 'Welche Bedeutung hat das Spenden im Islam?',
  faq6A: '"Sadaqah" aus dem Arabischem beschreibt die Form von Hilfe, die denjenigen geleistet wird, die sich in Not befinden. Es ist eine Möglichkeit, sich selbst und anderen zu helfen, indem man das eigene Herz öffnet und Bedürftige unterstützt.',
  thankTitle: 'Danke',
  thankSubtitle: 'Möge Allah(c.c) Ihre Spenden annehmen',
  thankImamLabel: 'UNSER IMAM',
  thankImamName: 'IMAM MUAMMER AĞYAR',
  thankImamText: 'Sehr geehrte Damen und Herren, im Namen aller Vereinsmitglieder möchte ich mich ganz herzlich für Ihre großzügige Spende bedanken. Durch Ihre Spenden kommen wir unserem Ziel einen Schritt näher. Wir würden uns freuen, wenn Sie von unseren Aktivitäten berichten könnten, da wir auf solche Spenden angewiesen sind.',
  thankImamClose: 'Wir zählen auf Sie!',
  thankImamOrg: 'DITIB Türkische islamische Gemeinde zu Willich e. V.',
  thankCTA: 'Jetzt Spenden',
  footerTax: 'Feststellung',
  footerTaxText: 'Umfang der Steuerbefreiung: Die Körperschaft ist nach § 5 Abs. 1. Nr. 9 KStG von Körperschaftsteuer befreit. Sie ist nach § 3 Nr. 6 GewStG von der Gewerbesteuer befreit. Die Körperschaft fördert im Sinne der §§ 51 ff. AO ausschließlich und unmittelbar folgende gemeinnützige Zwecke: Förderung der Religion (§ 52 Abs 2 Satz 1 Nr. 2 AO)',
  footerImpressum: 'Impressum',
  footerDatenschutz: 'Datenschutzerklärung',
  footerDesign: 'Gestaltung und Werbekampagnen Umsetzung von Caliskan Media GmbH',
  donateNow: 'Jetzt Sicher Spenden',
  // Contact Page
  contactTitle: 'Kontakt',
  contactSubtitle: 'Wir freuen uns auf Ihre Nachricht',
  contactAddress: 'Frankenseite 79, 47877 Willich, Deutschland',
  contactPhone: '+49 157 713 37 959',
  contactEmail: 'info@ditib-willich.de',
  contactFormTitle: 'Nachricht senden',
  contactFormName: 'Name',
  contactFormEmail: 'E-Mail',
  contactFormPhone: 'Telefon',
  contactFormSubject: 'Betreff',
  contactFormMessage: 'Ihre Nachricht',
  contactFormSubmit: 'Absenden',
  contactFormSuccess: 'Vielen Dank! Ihre Nachricht wurde erfolgreich gesendet.',
  contactFormError: 'Fehler beim Senden. Bitte versuchen Sie es erneut.',
  contactFindUs: 'So finden Sie uns',
  contactOpeningHours: 'Öffnungszeiten',
  // Cookie Consent
  cookieTitle: 'Cookie-Einstellungen',
  cookieText: 'Wir verwenden Cookies, um Ihre Erfahrung auf unserer Website zu verbessern. Einige sind essenziell, während andere uns helfen, diese Website und Ihre Erfahrung zu verbessern.',
  cookieAccept: 'Akzeptieren',
  cookieReadMore: 'Mehr erfahren',
  contactCtaTitle: 'Haben Sie Fragen?',
  contactCtaSubtitle: 'Unser Team hilft Ihnen gerne weiter.',
  contactCtaButton: 'Kontakt',
  impressumPageTitle: 'Impressum',
  impressumPageSubtitle: 'Angaben gemäß § 5 TMG',
  datenschutzPageTitle: 'Datenschutzerklärung',
  datenschutzPageSubtitle: 'Zuletzt aktualisiert: Januar 2026',
  teamPageTitle: 'Unser Vorstand',
  teamPageSubtitle: 'Die Vorstandsmitglieder der DITIB Willich Moschee',
  announcementsBadge: 'Aktuelle News',
  announcementsPageSubtitle: 'Die neuesten Nachrichten und Ankündigungen über unsere Moschee und unseren Verein.',
  announcementsEmpty: 'Noch keine Ankündigungen.',
  announcementsViewAll: 'Alle ansehen',
  announcementsReadMore: 'Weiterlesen',
  contactAddressLabel: 'Adresse',
  contactEmailLabel: 'Email',
  contactOpen24h: '24/7 Geöffnet',
  contactSending: 'Wird gesendet...',
  membershipTitle: 'Aufnahmeantrag',
  membershipOrgName: 'DITIB Türkisch-Islamische Gemeinde zu Willich e.V.',
  membershipSuccessTitle: 'Antrag eingegangen',
  membershipSuccessText: 'Ihr Aufnahmeantrag wurde erfolgreich empfangen. Wir werden uns in Kürze mit Ihnen in Verbindung setzen.',
  membershipBackHome: 'Zur Startseite',
  membershipSubmit: 'Antrag Senden',
  membershipSending: 'Wird gesendet...',
};

const tr: Translations = {
  dir: 'ltr',
  navAbout: 'Hakkımızda',
  navHistory: 'Tarihimiz',
  navFeatures: 'Özellikler',
  navRecentDonations: 'Son Bağışlar',
  navFaq: 'SSS',
  navTeam: 'Yönetim Kurulu',
  navMembership: 'Üye Kayıt',
  navAnnouncements: 'Duyurular',
  navContact: 'İletişim',
  recentDonationsTitle: 'Son Bağışlar',
  recentDonationsSubtitle: 'Topluluğumuz büyüyor – her bağış bizi hedefe yaklaştırıyor',
  recentDonationsLive: '🔴 Canlı',
  recentDonationsRaised: 'Toplanan Miktar',
  recentDonationsGoal: 'Hedef',
  recentDonationsDonors: 'Bağışçı',
  recentDonationsAgo: 'önce',
  recentDonationsShowMore: 'Daha Fazla Göster',
  // Prayer Times
  prayerTimesTitle: 'Namaz Vakitleri',
  prayerTimesLocation: 'Willich, Almanya',
  nextPrayer: 'Sonraki Namaz',
  prayerImsak: 'İmsak',
  prayerFajr: 'Sabah',
  prayerSunrise: 'Güneş',
  prayerDhuhr: 'Öğle',
  prayerAsr: 'İkindi',
  prayerMaghrib: 'Akşam',
  prayerIsha: 'Yatsı',
  prayerDaily: 'Günlük',
  prayerWeekly: 'Haftalık',
  prayerNote: '* Namaz vakitleri hesaplamalı olup gerçek vakitlerden birkaç dakika fark gösterebilir.',
  heroSubtitle: 'Türk İslam Topluluğu',
  heroCampaignTitle: 'Willich Cami Yardım Kampanyası',
  heroCampaignSubtitle: 'Her bağış önemlidir!',
  heroTitle: 'WİLLİCH',
  heroQuote: '"Kim Allah\'ın rızasını kazanmak için bir cami inşa ederse, Allah da ona cennette bir ev inşa eder."',
  heroQuoteSource: '(Hz. Muhammed ﷺ) — Buhâri, Salât 65; Müslim, Mesâcid 25, (533)',
  heroCTA: 'Güvenli Bağış Yap',
  heroSliderQuote: 'Toplumumuza şimdi yaptığınız yardım, bu nesiller ve gelecek nesiller için bir hediye olacaktır!',
  aboutTitle: 'Willich DITIB Türk İslam Topluluğu e.V.',
  aboutSubtitle: '1979\'dan beri',
  aboutText: 'DITIB Türk İslam Topluluğu Willich e. V., kayıtlı bir kar amacı gütmeyen dernek olarak Willich\'te faaliyet göstermektedir. Bölgedeki ilk Türk misafir işçiler tarafından kurulan dernek, Müslümanlar için ortak bir ibadet yeri ihtiyacını karşılamak amacıyla hayata geçirilmiştir.',
  aboutMosqueTitle: 'Camimizin Açılışı',
  aboutMosqueText: 'Camimiz 1979 yılında açıldı. Başlangıçta cami mekanları kiralandı, ancak zamanla dernek üyelerimizin ve fedakar Müslümanların desteğiyle binayı satın almak mümkün oldu. Yıllar içinde dini eğitim ve dinlenme odası olarak kullanılan yan bina da satın alınabildi.',
  aboutNewTitle: 'DITIB Willich Merkez Camii',
  aboutNewText1: 'DITIB Willich Merkez Camii projemizin resmi onayı 2023 yılında alınmış, inşaat ve uygulama süreci ise 2025 yılında başlamıştır. Bu anlamlı proje; Willich şehrinde yaşayan toplumumuza ibadet, eğitim, kültür ve sosyal dayanışma alanlarında hizmet verecek modern bir merkez kazandırmayı hedeflemektedir.',
  aboutNewText2: 'Camimiz yalnızca bir ibadet yeri değil; aynı zamanda çocuklarımızın ve gençlerimizin eğitim alabileceği, ailelerimizin bir araya gelebileceği, toplumsal birlikteliği güçlendirecek etkinliklerin düzenleneceği önemli bir yaşam merkezi olacaktır.',
  aboutNewText3: 'Toplumumuzun desteği, gönüllülerimizin emeği ve hayırseverlerimizin katkılarıyla ilerleyen bu proje, gelecek nesillere bırakılacak kalıcı bir eser olma yolunda emin adımlarla devam etmektedir.',
  aboutNewCallTitle: 'Birlikte güçlüyüz, birlikte başarıyoruz.',
  inspirationTitle: 'İlham Kaynağımız:',
  inspirationSubtitle: 'Ayasofya',
  inspirationCardTitle: 'Ayasofya Kubbesi',
  inspirationCardText: 'Eski cami binasının arsasında, tüm Willich bölgesini temsil eden, cemaat üyelerinin (çocuklar, gençler, aileler ve yaşlılar) ve ziyaretçilerin ihtiyaçlarını karşılayan bir cami inşa edilecektir. Willich\'in mimari dokusuna renk katmak için cami, Ayasofya örneğinde olduğu gibi klasik tarzda ve kubbeli olarak inşa edilecektir.',
  historyTitle: 'Tarihimiz',
  historySubtitle: 'Her şey nasıl başladı…',
  step1Title: 'Kuruluş',
  step1Text: '1979 yılında eski misafir işçiler DITIB Türk İslam Topluluğu Willich e. V.\'yi kurmaya karar verdi. Kendi ibadet yerine duyulan ihtiyaç, daha sonra bir arsa satın alınmasına yol açtı. Satın alınan arsa başlangıçta bir depo, daireler, mutfak, birkaç derslik ve özel bir fitness salonu barındırıyordu.',
  step2Title: 'Temel Atma',
  step2Text: 'Topluluğun sürekli büyümesi ve genişletilmiş mekanlara olan artan ihtiyaç nedeniyle yönetim kurulu, yalnızca bağışlarla finanse edilen yeni bir cami binası ve kültür merkezi inşa etmeye karar verdi. 2014 yılında ilk yapı izinleri başvurusu yapıldı. 2017 yılında eski binanın yıkımı başladı. Nihayet 12.10.2018\'de uzun zamandır beklenen temel atma töreni gerçekleşti.',
  step3Title: 'Bugün',
  step3Text: 'Ham inşaat yeni başlamışken, Corona inşaat çalışmalarını durma noktasına getirdi. Bu kesinti sadece zaman kaybına yol açmakla kalmadı, aynı zamanda gerekli malzemelerin fiyatlarını da artırdı. Pek çok engele rağmen 2022 yılı boyunca ham inşaat başarıyla tamamlandı.',
  step4Title: 'Gelecek',
  step4Text: 'Camiyi 4 yıl içinde tamamlama planı ne yazık ki gerçekleşmese de, bağışçılarımıza güveniyoruz ve inşallah camiyi yakında açmayı hedefliyoruz.',
  featuresTitle: 'Yeni Caminin Özellikleri',
  featuresSubtitle: 'Cami İnşaat Projemizden Görüntüler',
  basementTitle: 'Bodrum Kat',
  basement1: '1. Çay Odası & Çok Amaçlı Salon',
  basement1Text: 'Planlanan çay odası ve çok amaçlı salon, buluşmanın merkezi bir yeri olarak hizmet verecektir. Farklı kültürlerden Müslümanlar bir araya gelebilir ve topluluk içindeki iletişimi güçlendirebilir.',
  basement2: '2. Fitness Salonu',
  basement2Text: 'Sadece manevi değil, fiziksel sağlığın da hayatta denge kurmada önemli bir rol oynadığına inanıyoruz.',
  groundFloorTitle: 'Zemin Kat',
  ground1: '1. Kadın ve Erkek Namaz Salonları',
  ground1Text: '440m² alanda tüm Müslümanlar çeşitli ibadetlerini yerine getirebilecektir. Erkekler ve kadınlar için ayrı mekanlar sayesinde herkes günlük beş vakit namaz gibi kutsal görevlerini yerine getirebilir.',
  ground2: '2. Asansör & Engelli Tuvaletleri',
  ground2Text: 'Bir asansör ve engelli tuvaletlerinin yapımı, Willich Camisi\'ni herkes için erişilebilir kılacaktır.',
  firstFloorTitle: 'Birinci Kat',
  first1: '1. Kütüphane',
  first1Text: 'Willich Camisi ziyaretçilerinin ders kitapları okuyabileceği ve İslam hakkında yeni bilgiler edinebileceği bir eğitim yeri oluşturulacaktır.',
  first2: '2. Gençlik Odaları',
  first2Text: 'Willich Camisi aynı zamanda genç topluluğumuz için özel olarak tasarlanmış mekanlar da içermektedir. Bu odalar bir sığınak oluşturacak ve gençlere birlikte kaliteli zaman geçirme fırsatı sunacaktır.',
  secondFloorTitle: 'İkinci Kat',
  second1: '1. Misafir Konutu — İkinci katta ziyaretçilerimiz için üç daire bulunmaktadır.',
  second1Text: 'İkinci katta ziyaretçilerimiz için üç daire bulunmaktadır.',
  donationTitle: 'Bağış Süreci',
  donationSubtitle: 'Her bağış önemlidir!',
  dStep1Title: 'Adım 1 - Esnek Miktar',
  dStep1Text1: 'İlk adımda ne kadar bağış yapmak istediğinize siz karar verirsiniz.',
  dStep1Text2: '1 €\'lık küçük bir bağış bile topluluğumuza büyük destek olabilir ve inşaat çalışmalarını ilerletebilir.',
  dStep1Text3: 'Tereddüt etmeyin, en küçük bağışla bile büyük şeyler başarabilirsiniz!',
  dStep2Title: 'Adım 2 - Birçok Ödeme Seçeneği',
  dStep2Text: 'Daha sonra size çeşitli ödeme seçenekleri sunulacak ve bunlardan birini seçmeniz gerekecektir.',
  dStep2Text2: 'Güvenilir bir bağış işlemi bizim için özellikle önemlidir. Bu nedenle size %100 şeffaflık ve güvenlik vaat ediyoruz.',
  dStep3Title: 'Adım 3 - Bağış Onayı',
  dStep3Text: 'İstediğiniz ödeme yöntemini seçtikten sonra bağış sürecini tamamlayabilirsiniz. Allah size cennette bir ev nasip etsin.',
  dStep4Title: 'Adım 4 - Şeffaflık',
  dStep4Text1: 'Vaat ettiğimiz şeffaflığı sağlamak için, bağışınızın alınmasının ardından size bir bağış makbuzu göndereceğiz.',
  dStep4Text2: 'Gelen bağışlar yalnızca gerekli malzemelerin satın alınması ve devam eden inşaat çalışmaları için kullanılacaktır.',
  formTitle: 'Güvenli Bağış Yap',
  formSubtitle: 'DITIB WILLICH Cami Yardım Kampanyası',
  formAmountLabel: 'Bağış miktarı seçin',
  formCustomAmount: 'Özel miktar (€)',
  formPaymentMethod: 'Ödeme yöntemi',
  formCreditCard: 'Kredi Kartı',
  formPaypal: 'PayPal',
  formBankTransfer: 'Banka Havalesi',
  formName: 'Ad ve Soyad',
  formEmail: 'E-posta adresi',
  formMessage: 'Mesaj (isteğe bağlı)',
  formSubmit: 'Şimdi Bağış Yap',
  formBankDetails: 'Banka Bilgileri',
  formBankName: 'DITIB Türkisch Islamische Gemeinde zu Willich e.V.',
  formIBAN: 'IBAN: DE12 3456 7890 1234 5678 90',
  formBIC: 'BIC: DEUTDEDB',
  formReference: 'Açıklama: Cami İnşaatı Willich',
  formCardNumber: 'Kart Numarası',
  formExpiry: 'Son Kullanma Tarihi',
  formCVV: 'CVV',
  formCardHolder: 'Kart Sahibi',
  formPaypalInfo: 'Bağışınızı güvenli bir şekilde tamamlamak için PayPal\'a yönlendirileceksiniz.',
  faqTitle: 'S&C',
  faqSubtitle: 'Sık Sorulan Sorular',
  faq1Q: 'Bağışım ne olacak?',
  faq1A: 'Bağışınız inşaat çalışmalarının temelini oluşturur. Gelen bağışlar sayesinde önemli inşaat aşamaları desteklenmektedir.',
  faq2Q: 'Ditib aslında kimdir?',
  faq2A: 'Ditib, Almanya\'da Türk kültürünü ve İslam\'ı destekleyen ve koruyan bir Türk-İslam derneğidir. 1984 yılında Türk hükümeti tarafından kurulmuş olup 900 cami ve 900.000\'den fazla üyesiyle Almanya genelinde en büyük cami ve İslam din eğitimi sağlayıcısıdır.',
  faq3Q: 'Bağışımın alındığını nasıl öğrenirim?',
  faq3A: 'Şeffaf bir bağış işlemi sağlamak için, bağışınızın alınmasının ardından dijital bir onay alacaksınız.',
  faq4Q: 'Cami faizle mi inşa ediliyor?',
  faq4A: 'İslam\'da faiz almak ve ödemek yasaktır. Camimizin inşaatı cemaat üyelerimizin yardımıyla başlatılmış ve şimdiye kadar herhangi bir faiz etkisi olmaksızın finanse edilmiştir.',
  faq5Q: 'Bağışım vergiden düşülebilir mi?',
  faq5A: 'Evet, kar amacı gütmeyen bir dernek olarak tanındığımız için bağışınızı vergiden düşebilirsiniz. Bağışınızın ardından bir bağış makbuzu alacaksınız.',
  faq6Q: 'İslam\'da bağışın önemi nedir?',
  faq6A: 'Arapçadan gelen "Sadaka", ihtiyaç içinde olanlara yapılan yardım biçimini tanımlar. Kendi kalbini açarak ve ihtiyaç sahiplerini destekleyerek hem kendine hem de başkalarına yardım etmenin bir yoludur.',
  thankTitle: 'Teşekkür',
  thankSubtitle: 'Allah(c.c) bağışlarınızı kabul etsin',
  thankImamLabel: 'İMAMIMIZ',
  thankImamName: 'İMAM MUAMMER AĞYAR',
  thankImamText: 'Sayın Hanımefendi ve Beyefendiler, tüm dernek üyeleri adına cömert bağışınız için içtenlikle teşekkür etmek istiyorum. Bağışlarınız sayesinde hedefimize bir adım daha yaklaşıyoruz. Bu tür bağışlara muhtaç olduğumuzdan, faaliyetlerimizi anlatırsanız çok memnun oluruz.',
  thankImamClose: 'Size güveniyoruz!',
  thankImamOrg: 'DITIB Türk İslam Topluluğu Willich e. V.',
  thankCTA: 'Şimdi Bağış Yap',
  footerTax: 'Tespit',
  footerTaxText: 'Vergi muafiyetinin kapsamı: Kurum, KStG § 5 Abs. 1 Nr. 9 uyarınca kurumlar vergisinden muaftır. GewStG § 3 Nr. 6 uyarınca ticaret vergisinden muaftır.',
  footerImpressum: 'Künye',
  footerDatenschutz: 'Gizlilik Politikası',
  footerDesign: 'Tasarım ve Reklam Kampanyaları Caliskan Media GmbH tarafından',
  donateNow: 'Güvenli Bağış Yap',
  // Contact Page
  contactTitle: 'İletişim',
  contactSubtitle: 'Mesajınızı bekliyoruz',
  contactAddress: 'Frankenseite 79, 47877 Willich, Almanya',
  contactPhone: '+49 157 713 37 959',
  contactEmail: 'info@ditib-willich.de',
  contactFormTitle: 'Mesaj Gönder',
  contactFormName: 'İsim',
  contactFormEmail: 'E-posta',
  contactFormPhone: 'Telefon',
  contactFormSubject: 'Konu',
  contactFormMessage: 'Mesajınız',
  contactFormSubmit: 'Gönder',
  contactFormSuccess: 'Teşekkürler! Mesajınız başarıyla gönderildi.',
  contactFormError: 'Gönderme hatası. Lütfen tekrar deneyin.',
  contactFindUs: 'Bizi nasıl bulabilirsiniz',
  contactOpeningHours: 'Çalışma Saatleri',
  // Cookie Consent
  cookieTitle: 'Çerez Ayarları',
  cookieText: 'Web sitemizdeki deneyiminizi geliştirmek için çerezleri kullanıyoruz. Bazıları temel işlevler için gerekliyken, diğerleri sitemizi ve deneyiminizi iyileştirmemize yardımcı olur.',
  cookieAccept: 'Kabul Et',
  cookieReadMore: 'Daha Fazla Bilgi',
  contactCtaTitle: 'Sorularınız mı var?',
  contactCtaSubtitle: 'Ekibimiz size memnuniyetle yardımcı olur.',
  contactCtaButton: 'İletişim',
  impressumPageTitle: 'Künye',
  impressumPageSubtitle: '§ 5 TTK uyarınca bilgiler',
  datenschutzPageTitle: 'Gizlilik Politikası',
  datenschutzPageSubtitle: 'Son güncelleme: Ocak 2026',
  teamPageTitle: 'Yönetim Kurulumuz',
  teamPageSubtitle: 'DITIB Willich camii yönetim kurulu üyelerimiz',
  announcementsBadge: 'Güncel Haberler',
  announcementsPageSubtitle: 'Camimiz ve derneğimiz ile ilgili en güncel haberler ve duyurular.',
  announcementsEmpty: 'Henüz duyuru bulunmamaktadır.',
  announcementsViewAll: 'Tümünü Gör',
  announcementsReadMore: 'Devamını Oku',
  contactAddressLabel: 'Adres',
  contactEmailLabel: 'E-posta',
  contactOpen24h: '7/24 Açık',
  contactSending: 'Gönderiliyor...',
  membershipTitle: 'Üye Kayıt Formu',
  membershipOrgName: 'DITIB Türkisch-Islamische Gemeinde zu Willich e.V.',
  membershipSuccessTitle: 'Başvurunuz Alındı',
  membershipSuccessText: 'Üyelik başvurunuz başarıyla alınmıştır. En kısa sürede sizinle iletişime geçeceğiz.',
  membershipBackHome: 'Ana Sayfaya Dön',
  membershipSubmit: 'Başvuruyu Gönder',
  membershipSending: 'Gönderiliyor...',
};

const en: Translations = {
  dir: 'ltr',
  navAbout: 'About Us',
  navHistory: 'History',
  navFeatures: 'Features',
  navRecentDonations: 'Recent Donations',
  navFaq: 'FAQ',
  navTeam: 'Board of Directors',
  navMembership: 'Membership',
  navAnnouncements: 'Announcements',
  navContact: 'Contact',
  recentDonationsTitle: 'Recent Donations',
  recentDonationsSubtitle: 'Our community is growing – every donation brings us closer to the goal',
  recentDonationsLive: '🔴 Live',
  recentDonationsRaised: 'Raised So Far',
  recentDonationsGoal: 'Total Goal',
  recentDonationsDonors: 'Donors',
  recentDonationsAgo: 'ago',
  recentDonationsShowMore: 'Show More',
  // Prayer Times
  prayerTimesTitle: 'Prayer Times',
  prayerTimesLocation: 'Willich, Germany',
  nextPrayer: 'Next Prayer',
  prayerImsak: 'Imsak',
  prayerFajr: 'Fajr',
  prayerSunrise: 'Sunrise',
  prayerDhuhr: 'Dhuhr',
  prayerAsr: 'Asr',
  prayerMaghrib: 'Maghrib',
  prayerIsha: 'Isha',
  prayerDaily: 'Daily',
  prayerWeekly: 'Weekly',
  prayerNote: '* Prayer times are calculated and may differ from actual times by a few minutes.',
  heroSubtitle: 'Turkish Islamic Community',
  heroCampaignTitle: 'Willich Mosque Aid Campaign',
  heroCampaignSubtitle: 'Every donation matters!',
  heroTitle: 'WILLICH',
  heroQuote: '"Whoever builds a mosque for the sake of Allah, Allah will build for him a house in Paradise."',
  heroQuoteSource: '(Prophet Muhammad ﷺ) — Bukhari, Salat 65; Muslim, Masajid 25, (533)',
  heroCTA: 'Donate Securely Now',
  heroSliderQuote: 'The help you provide for our community now will be a gift for this and the coming generations!',
  aboutTitle: 'DITIB Turkish Islamic Community of Willich e.V.',
  aboutSubtitle: 'Since 1979',
  aboutText: 'The DITIB Turkish Islamic Community of Willich e. V. has existed as a registered non-profit association in Willich. Originally founded by the first Turkish guest workers in the region, the association was established to meet the growing need for a common place of worship for Muslims.',
  aboutMosqueTitle: 'The Opening of Our Mosque',
  aboutMosqueText: 'Our mosque was opened in 1979. Initially the premises were rented, but over time, thanks to the support of our members and dedicated Muslims, it became possible to purchase the building. Over the years, the adjacent building was also acquired for religious education and as a common room.',
  aboutNewTitle: 'DITIB Willich Central Mosque',
  aboutNewText1: 'The official approval for our DITIB Willich Central Mosque project was obtained in 2023, and the construction and implementation process began in 2025. This meaningful project aims to provide our community living in Willich with a modern center for worship, education, culture, and social solidarity.',
  aboutNewText2: 'Our mosque is not only a place of worship but also an important life center where our children and youth can receive education, our families can come together, and events that strengthen social cohesion can be organized.',
  aboutNewText3: 'This project, driven by the support of our community, the work of our volunteers, and the contributions of our benefactors, continues steadily on its way to being a lasting legacy for future generations.',
  aboutNewCallTitle: 'Together we are strong, together we succeed.',
  inspirationTitle: 'Our Inspiration:',
  inspirationSubtitle: 'The Hagia Sophia',
  inspirationCardTitle: 'The Dome of the Hagia Sophia',
  inspirationCardText: 'On the site of the former mosque building, a mosque representative of the entire Willich region is to be built, meeting the wishes of community members (children, youth, families and seniors) and visitors. To add more color to the architectural landscape of Willich, the mosque will be built in the classical style with a dome, just like the model of the Hagia Sophia.',
  historyTitle: 'Our History',
  historySubtitle: 'How it all began…',
  step1Title: 'Foundation',
  step1Text: 'In 1979, former guest workers decided to found the DITIB Turkish Islamic Community of Willich e. V. The need for their own place of worship led to the later acquisition of a property. The acquired property originally housed a warehouse, with apartments, a kitchen, several classrooms and a private fitness studio.',
  step2Title: 'Foundation Stone',
  step2Text: 'With the continuous growth of the community and the increasing need for expanded premises, the board decided to build a new mosque building and cultural center financed solely by donations. In 2014, the first building applications were submitted. In 2017, demolition of the old building began. Finally, on 12.10.2018, the long-awaited foundation stone laying took place.',
  step3Title: 'Today',
  step3Text: 'Just as the shell construction had begun, Corona forced a standstill in construction work. This interruption not only led to loss of time, but also drove up the prices of required materials. Despite many hurdles, the shell construction was successfully completed in 2022.',
  step4Title: 'Future',
  step4Text: 'Although the plan to complete the mosque within 4 years unfortunately did not work out, we have confidence in our donors and are pursuing the goal of opening the mosque soon, InshaAllah.',
  featuresTitle: 'Features of the New Mosque',
  featuresSubtitle: 'Images from Our Mosque Construction Project',
  basementTitle: 'Basement',
  basement1: '1. Tea Room & Multi-Purpose Room',
  basement1Text: 'The planned tea room and multi-purpose room serve as a central meeting place. Muslims from different cultures can meet here and strengthen communication within the community.',
  basement2: '2. Fitness Room',
  basement2Text: 'We firmly believe that not only spiritual but also physical health plays an essential role in building balance in life.',
  groundFloorTitle: 'Ground Floor',
  ground1: '1. Men and Women Prayer Rooms',
  ground1Text: 'On an area of 440m², all Muslims have the opportunity to perform their various acts of worship. With separate facilities for men and women, everyone can fulfill their sacred duties such as the five daily prayers.',
  ground2: '2. Elevator & Accessible Restrooms',
  ground2Text: 'An elevator and the installation of accessible toilets will make visiting the Willich Mosque possible and easy for everyone.',
  firstFloorTitle: 'First Floor',
  first1: '1. Library',
  first1Text: 'A place of further education will be established where visitors to the Willich Mosque can read textbooks and acquire new knowledge about Islam.',
  first2: '2. Youth Rooms',
  first2Text: 'The Willich Mosque also includes specially adapted rooms for our young community. These rooms will form a retreat and give young people the opportunity to spend quality time together.',
  secondFloorTitle: 'Second Floor',
  second1: '1. Visitor Accommodation — There are three apartments on the second floor for our visitors.',
  second1Text: 'There are three apartments on the second floor for our visitors.',
  donationTitle: 'Donation Process',
  donationSubtitle: 'Every donation counts!',
  dStep1Title: 'Step 1 - Flexible Amount',
  dStep1Text1: 'In the first step, you decide how much you want to donate and enter this amount.',
  dStep1Text2: 'Even a small donation of €1 can be a great support to our community and advance the construction work.',
  dStep1Text3: 'So don\'t hesitate, because even the smallest donation can make a big difference!',
  dStep2Title: 'Step 2 - Many Payment Options',
  dStep2Text: 'Next, you will be offered various payment options, from which you must choose one.',
  dStep2Text2: 'Reliable donation processing is of particular importance to us. Therefore, we promise you 100% transparency and security.',
  dStep3Title: 'Step 3 - Donation Confirmation',
  dStep3Text: 'Once you have selected your desired payment method, you can complete the donation process. May Allah grant you a house in al-Jannah.',
  dStep4Title: 'Step 4 - Transparency',
  dStep4Text1: 'To provide you with the assured transparency, you will receive a donation receipt from us after your donation has been received.',
  dStep4Text2: 'Incoming donations are used exclusively for the purchase of required materials and for ongoing construction work.',
  formTitle: 'Donate Securely Now',
  formSubtitle: 'DITIB WILLICH Mosque Aid Campaign',
  formAmountLabel: 'Choose donation amount',
  formCustomAmount: 'Custom amount (€)',
  formPaymentMethod: 'Payment method',
  formCreditCard: 'Credit Card',
  formPaypal: 'PayPal',
  formBankTransfer: 'Bank Transfer',
  formName: 'First and Last Name',
  formEmail: 'Email address',
  formMessage: 'Message (optional)',
  formSubmit: 'Donate Now',
  formBankDetails: 'Bank Details',
  formBankName: 'DITIB Turkish Islamic Community of Willich e.V.',
  formIBAN: 'IBAN: DE12 3456 7890 1234 5678 90',
  formBIC: 'BIC: DEUTDEDB',
  formReference: 'Reference: Mosque Construction Willich',
  formCardNumber: 'Card Number',
  formExpiry: 'Expiry Date',
  formCVV: 'CVV',
  formCardHolder: 'Cardholder',
  formPaypalInfo: 'You will be redirected to PayPal to securely complete your donation.',
  faqTitle: 'Q&A',
  faqSubtitle: 'Frequently Asked Questions',
  faq1Q: 'What happens to my donation?',
  faq1A: 'Your donation forms the basis of the construction work. Incoming donations support the individual important construction phases.',
  faq2Q: 'Who is Ditib?',
  faq2A: 'Ditib is a Turkish Islamic association in Germany that promotes and preserves Turkish culture and Islam. Founded in 1984 by the Turkish government, with 900 mosques and over 900,000 members, it is the largest provider of mosques and Islamic religious education in Germany.',
  faq3Q: 'How do I know if my donation has been received?',
  faq3A: 'To provide you with a traceable donation process, you will receive a digital confirmation after your donation has been received.',
  faq4Q: 'Is the mosque being built with interest?',
  faq4A: 'The collection and payment of interest is not permitted in Islam. The construction of our mosque was started with the help of our community members and has been financed so far without any influence of interest.',
  faq5Q: 'Is my donation tax-deductible?',
  faq5A: 'Yes, as we are recognized as a non-profit association, you can deduct your donation for tax purposes. You will receive a donation receipt after your donation.',
  faq6Q: 'What is the significance of donating in Islam?',
  faq6A: '"Sadaqah" from Arabic describes the form of help given to those in need. It is a way to help yourself and others by opening your own heart and supporting those in need.',
  thankTitle: 'Thank You',
  thankSubtitle: 'May Allah(s.w.t) accept your donations',
  thankImamLabel: 'OUR IMAM',
  thankImamName: 'IMAM MUAMMER AĞYAR',
  thankImamText: 'Dear Ladies and Gentlemen, on behalf of all association members, I would like to sincerely thank you for your generous donation. Through your donations, we are getting one step closer to our goal. We would be happy if you could tell others about our activities, as we depend on such donations.',
  thankImamClose: 'We count on you!',
  thankImamOrg: 'DITIB Turkish Islamic Community of Willich e. V.',
  thankCTA: 'Donate Now',
  footerTax: 'Statement',
  footerTaxText: 'Scope of tax exemption: The corporation is exempt from corporate income tax pursuant to § 5 Para. 1 No. 9 KStG. It is exempt from trade tax pursuant to § 3 No. 6 GewStG.',
  footerImpressum: 'Imprint',
  footerDatenschutz: 'Privacy Policy',
  footerDesign: 'Design and advertising campaigns by Caliskan Media GmbH',
  donateNow: 'Donate Securely Now',
  // Contact Page
  contactTitle: 'Contact',
  contactSubtitle: 'We look forward to your message',
  contactAddress: 'Frankenseite 79, 47877 Willich, Germany',
  contactPhone: '+49 157 713 37 959',
  contactEmail: 'info@ditib-willich.de',
  contactFormTitle: 'Send Message',
  contactFormName: 'Name',
  contactFormEmail: 'Email',
  contactFormPhone: 'Phone',
  contactFormSubject: 'Subject',
  contactFormMessage: 'Your Message',
  contactFormSubmit: 'Submit',
  contactFormSuccess: 'Thank you! Your message has been sent successfully.',
  contactFormError: 'Error sending. Please try again.',
  contactFindUs: 'How to find us',
  contactOpeningHours: 'Opening Hours',
  // Cookie Consent
  cookieTitle: 'Cookie Settings',
  cookieText: 'We use cookies to improve your experience on our website. Some are essential, while others help us to improve this website and your experience.',
  cookieAccept: 'Accept',
  cookieReadMore: 'Learn More',
  contactCtaTitle: 'Do you have questions?',
  contactCtaSubtitle: 'Our team is happy to help you.',
  contactCtaButton: 'Contact',
  impressumPageTitle: 'Imprint',
  impressumPageSubtitle: 'Information according to § 5 TMG',
  datenschutzPageTitle: 'Privacy Policy',
  datenschutzPageSubtitle: 'Last updated: January 2026',
  teamPageTitle: 'Our Board',
  teamPageSubtitle: 'Board members of DITIB Willich Mosque',
  announcementsBadge: 'Latest News',
  announcementsPageSubtitle: 'The latest news and announcements about our mosque and association.',
  announcementsEmpty: 'No announcements yet.',
  announcementsViewAll: 'View All',
  announcementsReadMore: 'Read More',
  contactAddressLabel: 'Address',
  contactEmailLabel: 'Email',
  contactOpen24h: '24/7 Open',
  contactSending: 'Sending...',
  membershipTitle: 'Membership Application',
  membershipOrgName: 'DITIB Turkish Islamic Community of Willich e.V.',
  membershipSuccessTitle: 'Application Received',
  membershipSuccessText: 'Your membership application has been received successfully. We will contact you shortly.',
  membershipBackHome: 'Back to Home',
  membershipSubmit: 'Submit Application',
  membershipSending: 'Sending...',
};

const ar: Translations = {
  dir: 'rtl',
  navAbout: 'من نحن',
  navHistory: 'تاريخنا',
  navFeatures: 'المميزات',
  navRecentDonations: 'آخر التبرعات',
  navFaq: 'الأسئلة الشائعة',
  navTeam: 'مجلس الإدارة',
  navMembership: 'طلب عضوية',
  navAnnouncements: 'الإعلانات',
  navContact: 'اتصل بنا',
  recentDonationsTitle: 'آخر التبرعات',
  recentDonationsSubtitle: 'مجتمعنا ينمو – كل تبرع يقربنا من الهدف',
  recentDonationsLive: '🔴 مباشر',
  recentDonationsRaised: 'تم جمعه حتى الآن',
  recentDonationsGoal: 'الهدف الكلي',
  recentDonationsDonors: 'المتبرعون',
  recentDonationsAgo: 'منذ',
  recentDonationsShowMore: 'عرض المزيد',
  // Prayer Times
  prayerTimesTitle: 'أوقات الصلاة',
  prayerTimesLocation: 'ويليش، ألمانيا',
  nextPrayer: 'الصلاة القادمة',
  prayerImsak: 'الإمساك',
  prayerFajr: 'الفجر',
  prayerSunrise: 'الشروق',
  prayerDhuhr: 'الظهر',
  prayerAsr: 'العصر',
  prayerMaghrib: 'المغرب',
  prayerIsha: 'العشاء',
  prayerDaily: 'يومي',
  prayerWeekly: 'أسبوعي',
  prayerNote: '* أوقات الصلاة تقريبية وقد تختلف عن الأوقات الفعلية بدقائق.',
  heroSubtitle: 'الجمعية الإسلامية التركية',
  heroCampaignTitle: 'حملة مساعدة مسجد ويليش',
  heroCampaignSubtitle: 'كل تبرع مهم!',
  heroTitle: 'WİLLİCH',
  heroQuote: '"من بنى مسجداً لله، بنى الله له بيتاً في الجنة"',
  heroQuoteSource: '(النبي محمد ﷺ) — البخاري، الصلاة 65؛ مسلم، المساجد 25، (533)',
  heroCTA: 'تبرع الآن بأمان',
  heroSliderQuote: 'المساعدة التي تقدمها لمجتمعنا الآن ستكون هدية لهذا الجيل والأجيال القادمة!',
  aboutTitle: 'جمعية DITIB الإسلامية التركية في ويليش',
  aboutSubtitle: 'منذ عام 1979',
  aboutText: 'تأسست جمعية DITIB الإسلامية التركية في ويليش كجمعية خيرية مسجلة. أسسها العمال الأتراك الأوائل في المنطقة لتلبية الحاجة المتزايدة لمكان عبادة مشترك للمسلمين.',
  aboutMosqueTitle: 'افتتاح مسجدنا',
  aboutMosqueText: 'افتُتح مسجدنا عام 1979. في البداية كانت المرافق مستأجرة، لكن بمرور الوقت وبفضل دعم أعضاء الجمعية والمسلمين المتفانين، أصبح من الممكن شراء المبنى. وعلى مر السنين، تم أيضاً الحصول على المبنى المجاور للتعليم الديني وكغرفة مشتركة.',
  aboutNewTitle: 'مسجد ديتاب ويليش المركزي',
  aboutNewText1: 'تم الحصول على الموافقة الرسمية لمشروع مسجد ديتاب ويليش المركزي في عام 2023، وبدأت عملية البناء والتنفيذ في عام 2025. يهدف هذا المشروع الهام إلى تزويد مجتمعنا في ويليش بمركز حديث للعبادة والتعليم والثقافة والتضامن الاجتماعي.',
  aboutNewText2: 'مسجدنا ليس مجرد مكان للعبادة، بل هو أيضاً مركز حياة مهم حيث يمكن لأطفالنا وشبابنا الحصول على التعليم، ويمكن لعائلاتنا الالتقاء، ويمكن تنظيم فعاليات تعزز التماسك الاجتماعي.',
  aboutNewText3: 'هذا المشروع، الذي يتقدم بفضل دعم مجتمعنا وعمل متطوعينا ومساهمات مانحينا، يستمر بخطى ثابتة في طريقه ليصبح إرثاً دائماً للأجيال القادمة.',
  aboutNewCallTitle: 'معاً نحن أقوياء، معاً ننجح.',
  inspirationTitle: 'مصدر إلهامنا:',
  inspirationSubtitle: 'آيا صوفيا',
  inspirationCardTitle: 'قبة آيا صوفيا',
  inspirationCardText: 'على أرض المبنى القديم للمسجد، سيُبنى مسجد يمثل منطقة ويليش بأكملها، يلبي رغبات أعضاء المجتمع (الأطفال والشباب والعائلات وكبار السن) والزوار. لإضافة لون للمشهد المعماري في ويليش، سيُبنى المسجد بالأسلوب الكلاسيكي مع قبة، تماماً مثل نموذج آيا صوفيا.',
  historyTitle: 'تاريخنا',
  historySubtitle: 'كيف بدأ كل شيء...',
  step1Title: 'التأسيس',
  step1Text: 'في عام 1979، قرر العمال الأتراك السابقون تأسيس جمعية DITIB الإسلامية التركية في ويليش. أدت الحاجة إلى مكان عبادة خاص إلى الحصول لاحقاً على قطعة أرض. كانت الأرض المكتسبة تحتوي في الأصل على مستودع مع شقق ومطبخ وعدة فصول دراسية وصالة لياقة بدنية خاصة.',
  step2Title: 'وضع حجر الأساس',
  step2Text: 'مع النمو المستمر للمجتمع والحاجة المتزايدة لمرافق موسعة، قرر مجلس الإدارة بناء مبنى مسجد جديد ومركز ثقافي يُموَّل فقط من التبرعات. في عام 2014 قُدِّمت أولى طلبات البناء. في عام 2017 بدأ هدم المبنى القديم. وأخيراً، في 12.10.2018، جرى وضع حجر الأساس المنتظر منذ فترة طويلة.',
  step3Title: 'اليوم',
  step3Text: 'بينما كان البناء الهيكلي قد بدأ للتو، أجبر كوفيد-19 على توقف أعمال البناء. لم يؤدِّ هذا الانقطاع إلى خسارة في الوقت فحسب، بل رفع أيضاً أسعار المواد المطلوبة. على الرغم من العقبات الكثيرة، اكتمل البناء الهيكلي بنجاح خلال عام 2022.',
  step4Title: 'المستقبل',
  step4Text: 'على الرغم من أن خطة إكمال المسجد في غضون 4 سنوات لم تتحقق للأسف، إلا أننا نثق بمتبرعينا ونسعى إلى افتتاح المسجد قريباً إن شاء الله.',
  featuresTitle: 'مميزات المسجد الجديد',
  featuresSubtitle: 'صور من مشروع بناء مسجدنا',
  basementTitle: 'الطابق السفلي',
  basement1: '1. غرفة الشاي والقاعة متعددة الأغراض',
  basement1Text: 'ستكون غرفة الشاي والقاعة متعددة الأغراض المخططة مكاناً مركزياً للتجمع. يمكن للمسلمين من ثقافات مختلفة الالتقاء هنا وتعزيز التواصل داخل المجتمع.',
  basement2: '2. صالة اللياقة البدنية',
  basement2Text: 'نؤمن إيماناً راسخاً بأن الصحة الجسدية، إلى جانب الصحة الروحية، تلعب دوراً أساسياً في بناء التوازن في الحياة.',
  groundFloorTitle: 'الطابق الأرضي',
  ground1: '1. قاعات صلاة الرجال والنساء',
  ground1Text: 'على مساحة 440 متراً مربعاً، يمكن لجميع المسلمين ممارسة عباداتهم المختلفة. بفضل المرافق المنفصلة للرجال والنساء، يمكن للجميع أداء واجباتهم المقدسة كالصلوات الخمس اليومية.',
  ground2: '2. مصعد ودورات مياه للمعاقين',
  ground2Text: 'سيجعل المصعد وتركيب دورات مياه للمعاقين زيارة مسجد ويليش ممكنة وسهلة للجميع.',
  firstFloorTitle: 'الطابق الأول',
  first1: '1. مكتبة',
  first1Text: 'سيُنشأ مكان للتعليم المستمر حيث يمكن لزوار مسجد ويليش قراءة الكتب المدرسية واكتساب معرفة جديدة حول الإسلام.',
  first2: '2. غرف الشباب',
  first2Text: 'يتضمن مسجد ويليش أيضاً غرفاً مصممة خصيصاً لمجتمعنا الشبابي. ستشكل هذه الغرف ملاذاً وتمنح الشباب فرصة قضاء وقت ممتع معاً.',
  secondFloorTitle: 'الطابق الثاني',
  second1: '1. إقامة الزوار — يوجد في الطابق الثاني ثلاث شقق لزوارنا.',
  second1Text: 'تتوفر ثلاث شقق في الطابق الثاني لاستقبال زوارنا الكرام.',
  donationTitle: 'عملية التبرع',
  donationSubtitle: 'كل تبرع مهم!',
  dStep1Title: 'الخطوة 1 - مبلغ مرن',
  dStep1Text1: 'في الخطوة الأولى، تقرر أنت كم تريد التبرع وتدخل هذا المبلغ.',
  dStep1Text2: 'حتى تبرع صغير بمقدار 1 يورو يمكن أن يكون دعماً كبيراً لمجتمعنا ويدفع أعمال البناء إلى الأمام.',
  dStep1Text3: 'لا تتردد، فحتى أصغر تبرع يمكن أن يُحدث فرقاً كبيراً!',
  dStep2Title: 'الخطوة 2 - خيارات دفع متعددة',
  dStep2Text: 'بعد ذلك، ستُعرض عليك خيارات دفع متعددة يجب عليك اختيار أحدها.',
  dStep2Text2: 'معالجة التبرعات الموثوقة ذات أهمية خاصة بالنسبة لنا. لذلك نعدك بـ 100٪ شفافية وأمان.',
  dStep3Title: 'الخطوة 3 - تأكيد التبرع',
  dStep3Text: 'بمجرد اختيار طريقة الدفع المطلوبة، يمكنك إتمام عملية التبرع. جعل الله لك بيتاً في الجنة.',
  dStep4Title: 'الخطوة 4 - الشفافية',
  dStep4Text1: 'لضمان الشفافية الموعودة، ستتلقى منا إيصال تبرع بعد استلام تبرعك.',
  dStep4Text2: 'تُستخدم التبرعات الواردة حصرياً لشراء المواد المطلوبة وللأعمال الإنشائية الجارية.',
  formTitle: 'تبرع الآن بأمان',
  formSubtitle: 'حملة مساعدة مسجد DITIB ويليش',
  formAmountLabel: 'اختر مبلغ التبرع',
  formCustomAmount: 'مبلغ مخصص (€)',
  formPaymentMethod: 'طريقة الدفع',
  formCreditCard: 'بطاقة ائتمان',
  formPaypal: 'باي بال',
  formBankTransfer: 'تحويل بنكي',
  formName: 'الاسم الأول والأخير',
  formEmail: 'عنوان البريد الإلكتروني',
  formMessage: 'رسالة (اختياري)',
  formSubmit: 'تبرع الآن',
  formBankDetails: 'تفاصيل البنك',
  formBankName: 'DITIB الجمعية الإسلامية التركية في ويليش',
  formIBAN: 'IBAN: DE12 3456 7890 1234 5678 90',
  formBIC: 'BIC: DEUTDEDB',
  formReference: 'المرجع: بناء المسجد ويليش',
  formCardNumber: 'رقم البطاقة',
  formExpiry: 'تاريخ الانتهاء',
  formCVV: 'CVV',
  formCardHolder: 'حامل البطاقة',
  formPaypalInfo: 'سيتم توجيهك إلى PayPal لإتمام تبرعك بأمان.',
  faqTitle: 'أسئلة وأجوبة',
  faqSubtitle: 'الأسئلة الشائعة',
  faq1Q: 'ماذا يحدث لتبرعي؟',
  faq1A: 'يشكل تبرعك أساس أعمال البناء. تدعم التبرعات الواردة مراحل البناء المهمة الفردية.',
  faq2Q: 'من هي ديتيب في الواقع؟',
  faq2A: 'ديتيب هي جمعية إسلامية تركية في ألمانيا تعمل على تعزيز وصون الثقافة التركية والإسلام. تأسست عام 1984 من قِبل الحكومة التركية، وبـ 900 مسجد وأكثر من 900,000 عضو، فهي أكبر مزود للمساجد والتعليم الديني الإسلامي في ألمانيا.',
  faq3Q: 'كيف أعرف إذا وصل تبرعي؟',
  faq3A: 'لتزويدك بعملية تبرع قابلة للتتبع، ستتلقى تأكيداً رقمياً بعد استلام تبرعك.',
  faq4Q: 'هل يُبنى المسجد بالربا؟',
  faq4A: 'أخذ الربا ودفعه غير مسموح به في الإسلام. بدأ بناء مسجدنا بمساعدة أعضاء مجتمعنا وتم تمويله حتى الآن دون أي تأثير للربا.',
  faq5Q: 'هل تبرعي معفى من الضرائب؟',
  faq5A: 'نعم، بما أننا معترف بنا كجمعية غير ربحية، يمكنك خصم تبرعك لأغراض ضريبية. ستتلقى إيصال تبرع بعد تبرعك.',
  faq6Q: 'ما أهمية التبرع في الإسلام؟',
  faq6A: '"الصدقة" من العربية تصف شكل المساعدة المقدمة لأولئك المحتاجين. إنها طريقة لمساعدة نفسك والآخرين من خلال فتح قلبك ودعم المحتاجين.',
  thankTitle: 'شكراً',
  thankSubtitle: 'تقبل الله تبرعاتكم',
  thankImamLabel: 'إمامنا',
  thankImamName: 'الإمام معمر أغيار',
  thankImamText: 'السادة الكرام، باسم جميع أعضاء الجمعية، أود أن أشكركم بصدق على تبرعكم الكريم. بتبرعاتكم نقترب خطوة من هدفنا. سنكون سعداء إذا تمكنتم من إخبار الآخرين عن أنشطتنا، حيث نعتمد على مثل هذه التبرعات.',
  thankImamClose: 'نعتمد عليكم!',
  thankImamOrg: 'جمعية DITIB الإسلامية التركية في ويليش',
  thankCTA: 'تبرع الآن',
  footerTax: 'إفادة',
  footerTaxText: 'نطاق الإعفاء الضريبي: الجمعية معفاة من ضريبة الشركات وفقاً للمادة 5 الفقرة 1 رقم 9 من قانون ضريبة الشركات.',
  footerImpressum: 'بيانات النشر',
  footerDatenschutz: 'سياسة الخصوصية',
  footerDesign: 'التصميم وتنفيذ الحملات الإعلانية من قِبل Caliskan Media GmbH',
  donateNow: 'تبرع الآن بأمان',
  // Contact Page
  contactTitle: 'اتصل بنا',
  contactSubtitle: 'نتطلع إلى رسالتك',
  contactAddress: 'Frankenseite 79, 47877 Willich, Germany',
  contactPhone: '+49 157 713 37 959',
  contactEmail: 'info@ditib-willich.de',
  contactFormTitle: 'إرسال رسالة',
  contactFormName: 'الاسم',
  contactFormEmail: 'البريد الإلكتروني',
  contactFormPhone: 'الهاتف',
  contactFormSubject: 'الموضوع',
  contactFormMessage: 'رسالتك',
  contactFormSubmit: 'إرسال',
  contactFormSuccess: 'شكراً لك! تم إرسال رسالتك بنجاح.',
  contactFormError: 'خطأ في الإرسال. يرجى المحاولة مرة أخرى.',
  contactFindUs: 'كيف تجدنا',
  contactOpeningHours: 'ساعات العمل',
  // Cookie Consent
  cookieTitle: 'إعدادات الكوكيز',
  cookieText: 'نحن نستخدم ملفات تعريف الارتباط لتحسين تجربتك على موقعنا. بعضها ضروري، بينما يساعدنا البعض الآخر في تحسين هذا الموقع وتجربتك.',
  cookieAccept: 'قبول',
  cookieReadMore: 'اقرأ أكثر',
  contactCtaTitle: 'هل لديك أسئلة؟',
  contactCtaSubtitle: 'فريقنا يسعده مساعدتك.',
  contactCtaButton: 'اتصل بنا',
  impressumPageTitle: 'بيانات النشر',
  impressumPageSubtitle: 'المعلومات وفقاً للمادة 5 TMG',
  datenschutzPageTitle: 'سياسة الخصوصية',
  datenschutzPageSubtitle: 'آخر تحديث: يناير 2026',
  teamPageTitle: 'مجلس الإدارة',
  teamPageSubtitle: 'أعضاء مجلس إدارة مسجد DITIB ويليش',
  announcementsBadge: 'آخر الأخبار',
  announcementsPageSubtitle: 'آخر الأخبار والإعلانات المتعلقة بمسجدنا وجمعيتنا.',
  announcementsEmpty: 'لا توجد إعلانات بعد.',
  announcementsViewAll: 'عرض الكل',
  announcementsReadMore: 'اقرأ المزيد',
  contactAddressLabel: 'العنوان',
  contactEmailLabel: 'البريد الإلكتروني',
  contactOpen24h: '24/7 مفتوح',
  contactSending: 'جارٍ الإرسال...',
  membershipTitle: 'طلب العضوية',
  membershipOrgName: 'جمعية DITIB الإسلامية التركية في ويليش',
  membershipSuccessTitle: 'تم استلام الطلب',
  membershipSuccessText: 'تم استلام طلب العضوية بنجاح. سنتواصل معكم قريباً.',
  membershipBackHome: 'العودة للرئيسية',
  membershipSubmit: 'إرسال الطلب',
  membershipSending: 'جارٍ الإرسال...',
};

export const translations: Record<Language, Translations> = { de, tr, en, ar };

export function getTranslations(language: Language): Translations {
  return translations[language];
}
